module.exports = __webpack_public_path__ + "files/f01a4402103c9ef9350607c0f739b49d.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-italic.woff2
 ** module id = 977
 ** module chunks = 0
 **/